// extracted by mini-css-extract-plugin
module.exports = {"twoColumn":"AccountForm_twoColumn__24Ofm","twoColumnField":"AccountForm_twoColumnField__3elan"};